// extracted by mini-css-extract-plugin
export default {"panel":"Pannel_panel__R4n93","panelTitle":"Pannel_panelTitle__AND3e"};